import React from 'react';
import {Outlet} from 'react-router-dom';

const FilterRules = () => {
    return <Outlet/>
};

export default FilterRules;